import { styled } from '@mui/material';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  mainBox: 'mainBox',
  dashboardHeader: 'dashboardHeader',
  dashboardHeaderContent: 'dashboardHeaderContent',
  dashboardHeaderLeft: 'dashboardHeaderLeft',
  dashboardHeaderRight: 'dashboardHeaderRight',
  dashboardTitle: 'dashboardTitle',
  documentTypeSelectWrapper: 'documentTypeSelectWrapper',
  documentTypeSelectionDropdown: 'documentTypeSelectionDropdown',
  dashboardTypeFilterButtonLeft: 'dashboardTypeFilterButtonLeft',
  dashboardTypeFilterButtonRight: 'dashboardTypeFilterButtonRight',
  mainBoxDashboardArea: 'mainBoxDashboardArea',
  generalDetailsSectionMain: 'generalDetailsSectionMain',
  generalDetailsSectionMainTitleBox: 'generalDetailsSectionMainTitleBox',
  dashboardGDMainGridMainContainers: 'dashboardGDMainGridMainContainers',
  dashboardGDMainGridMainContainersSection:
    'dashboardGDMainGridMainContainersSection',
  dashboardGDSectionTitle: 'dashboardGDSectionTitle',
  dashboardGDSectionMain: 'dashboardGDSectionMain',
  dashboardGDMainGrid: 'dashboardGDMainGrid',
  ahTableMainContainer: 'ahTableMainContainer',
  ahTableHead: 'ahTableHead',
  ahTableHeaderCell: 'ahTableHeaderCell',
  ahTableRowClass: 'ahTableRowClass',
  ahTableRowCell: 'ahTableRowCell',
  ahNavigationButton: 'ahNavigationButton',
  dashboardDTTitle: 'dashboardDTTitle',
  documentTypeSectionMain: 'documentTypeSectionMain',
  dashboardDocumentTypeSectionMainTitleBox:
    'dashboardDocumentTypeSectionMainTitleBox',
  dashboardDocumentTypeMainGrid: 'dashboardDocumentTypeMainGrid',
  dashboardDocumentTypeMainGridUHContainer:
    'dashboardDocumentTypeMainGridUHContainer',
  dashboardDTMainGridUHContainerSection:
    'dashboardDTMainGridUHContainerSection',
  dashboardDTUploadExportSectionTitle: 'dashboardDTUploadExportSectionTitle',
  dashboardDTUploadExportSectionMain: 'dashboardDTUploadExportSectionMain',
  dashboardDocumentTypeMainGridEHContainer:
    'dashboardDocumentTypeMainGridEHContainer',
  dashboardDTMainGridEHContainerSection:
    'dashboardDTMainGridEHContainerSection',
  dashboardDocumentTypeMainGridFCContainer:
    'dashboardDocumentTypeMainGridFCContainer',
  dashboardDTMainGridFCContainerSection:
    'dashboardDTMainGridFCContainerSection',
  dashboardDTFlowSectionTitle: 'dashboardDTFlowSectionTitle',
  dashboardDTFlowSectionMain: 'dashboardDTFlowSectionMain',
  fcNavigationButton: 'fcNavigationButton',
  fcTableMainContainer: 'fcTableMainContainer',
  fcTable: 'fcTable',
  fcTableRowClass: 'fcTableRowClass',
  fcNodeStepper: 'fcNodeStepper',
  connectionBoxStyle: 'connectionBoxStyle',
  connectionLogoStyle: 'connectionLogoStyle',
  fcStatusChipPadding: 'fcStatusChipPadding',
  fcStopChip: 'fcStopChip',
  fcRunningChip: 'fcRunningChip',
  fcNameTypo: 'fcNameTypo',
  fcTableRowCell: 'fcTableRowCell',
  dashboardDocumentTypeMainGridVDContainer:
    'dashboardDocumentTypeMainGridVDContainer',
  dashboardDTMainGridVDContainerSection:
    'dashboardDTMainGridVDContainerSection',
  dashboardDTValidateSectionTitle: 'dashboardDTValidateSectionTitle',
  dashboardDTValidateSectionMain: 'dashboardDTValidateSectionMain',
  dashboardDocumentTypeMainGridTDContainer:
    'dashboardDocumentTypeMainGridTDContainer',
  dashboardDTMainGridTDContainerSection:
    'dashboardDTMainGridTDContainerSection',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    // Root styles
  },
  [`& .${classes.mainBox}`]: {
    backgroundColor: theme.palette.darkPurple.lightest,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 40px)`, // remove header height
    },
    [up('md')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 50px)`, // remove header height
    },
    [up('xl')]: {
      height: `calc(100vh - ${theme.spacing(6)} - 64px)`, // remove header height
    },
  },
  [`& .${classes.dashboardHeader}`]: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.secondaryWhite.main,
    boxShadow: 'none',
    minHeight: '0px',
    borderTopLeftRadius: '10px',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    [up('xs')]: {
      height: '40px',
    },
    [up('md')]: {
      height: '50px',
    },
    [up('xl')]: {
      height: '64px',
    },
  },
  [`& .${classes.dashboardHeaderContent}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    [up('xs')]: {
      height: '24px',
      padding: '0px 12px',
    },
    [up('md')]: {
      height: '30px',
      padding: '0px 16px',
    },
    [up('xl')]: {
      height: '40px',
      padding: '0px 25px',
    },
  },
  [`& .${classes.dashboardHeaderLeft}`]: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    [up('xs')]: {
      gap: 8,
    },
    [up('md')]: {
      gap: 20,
    },
  },
  [`& .${classes.dashboardTitle}`]: {
    fontFamily: 'Heebo',
    fontWeight: '500',
    color: theme.palette.darkPurple.main,
  },
  [`& .${classes.documentTypeSelectWrapper}`]: {
    height: '100%',
    [up('xs')]: {
      width: '140px',
    },
    [up('sm')]: {
      width: '200px',
    },
    [up('md')]: {
      width: '300px',
    },
    [up('lg')]: {
      width: '350px',
    },
    [up('xl')]: {
      width: '400px',
    },
    [up('xxl')]: {
      width: '450px',
    },
  },
  [`& .${classes.documentTypeSelectionDropdown}`]: {
    height: '100%',
    width: '100%',
  },
  [`& .${classes.dashboardHeaderRight}`]: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  [`& .${classes.dashboardTypeFilterButtonLeft}`]: {
    height: '100%',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    [up('xs')]: {
      width: '30px',
    },
    [up('sm')]: {
      width: '80px',
    },
    [up('md')]: {
      width: '100px',
    },
    [up('lg')]: {
      width: '130px',
    },
  },
  [`& .${classes.dashboardTypeFilterButtonRight}`]: {
    height: '100%',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    [up('xs')]: {
      width: '30px',
    },
    [up('sm')]: {
      width: '80px',
    },
    [up('md')]: {
      width: '100px',
    },
    [up('lg')]: {
      width: '130px',
    },
  },
  [`& .${classes.mainBoxDashboardArea}`]: {
    [up('xs')]: {
      padding: '0px 10px',
    },
    [up('md')]: {
      padding: '0px 20px',
    },
  },
  [`& .${classes.generalDetailsSectionMain}`]: {
    display: 'flex',
    flexDirection: 'column',
    [up('xs')]: {
      padding: '12px 0px',
    },
    [up('md')]: {
      padding: '16px 0px',
    },
  },
  [`& .${classes.generalDetailsSectionMainTitleBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  [`& .${classes.dashboardGDMainGrid}`]: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [`& .${classes.dashboardGDMainGridMainContainers}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
    borderRadius: '10px',
    height: '400px',
    [up('xs')]: {
      height: '360px',
    },
    [up('sm')]: {
      height: '380px',
    },
    [up('xxl')]: {
      height: '400px',
    },
  },
  [`& .${classes.dashboardGDMainGridMainContainersSection}`]: {
    height: '100%',
    padding: '16px',
  },
  [`& .${classes.dashboardGDSectionTitle}`]: {
    height: '10%',
    width: '100%',
  },
  [`& .${classes.dashboardGDSectionMain}`]: {
    height: '90%',
    width: '100%',
  },
  [`& .${classes.ahTableMainContainer}`]: {
    [up('xs')]: {
      height: '90%',
    },
    boxShadow: 'none',
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      width: '0px',
    },
  },
  [`& .${classes.ahTableHead}`]: {
    background: theme.palette.deepAmethyst.lightest,
  },
  [`& .${classes.ahTableHeaderCell}`]: {
    background: theme.palette.deepAmethyst.lightest,
    color: theme.palette.deepAmethyst.main,
    fontFamily: 'Heebo',
    fontWeight: 400,
    padding: '10px 16px',
    [up('xs')]: {
      fontSize: '10px',
    },
    [up('sm')]: {
      fontSize: '11px',
    },
    [up('md')]: {
      fontSize: '11px',
    },
    [up('lg')]: {
      fontSize: '12px',
    },
    [up('xl')]: {
      fontSize: '14px',
    },
    [up('xxl')]: {
      fontSize: '16px',
    },
  },
  [`& .${classes.ahTableRowClass}`]: {
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
    },
  },
  [`& .${classes.ahTableRowCell}`]: {
    color: theme.palette.deepAmethyst.main,
    fontFamily: 'Heebo',
    fontWeight: 400,
    padding: '10px 16px',
    [up('xs')]: {
      fontSize: '10px',
    },
    [up('sm')]: {
      fontSize: '11px',
    },
    [up('md')]: {
      fontSize: '11px',
    },
    [up('lg')]: {
      fontSize: '12px',
    },
    [up('xl')]: {
      fontSize: '14px',
    },
    [up('xxl')]: {
      fontSize: '16px',
    },
  },
  [`& .${classes.fcNavigationButton}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '16px',
  },
  [`& .${classes.dashboardDTTitle}`]: {
    fontFamily: 'Heebo',
    fontWeight: '500',
    color: theme.palette.deepAmethyst.main,
  },
  [`& .${classes.documentTypeSectionMain}`]: {
    display: 'flex',
    flexDirection: 'column',
    [up('xs')]: {
      paddingBottom: '16px',
    },
  },
  [`& .${classes.dashboardDocumentTypeSectionMainTitleBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  [`& .${classes.dashboardDocumentTypeMainGrid}`]: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [`& .${classes.dashboardDocumentTypeMainGridUHContainer}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
    borderRadius: '10px',
    [up('xs')]: {
      height: '240px',
    },
    [up('md')]: {
      height: '280px',
    },
    [up('lg')]: {
      height: '300px',
    },
    [up('xl')]: {
      height: '340px',
    },
  },
  [`& .${classes.dashboardDTMainGridUHContainerSection}`]: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
  [`& .${classes.dashboardDTUploadExportSectionTitle}`]: {
    height: '10%',
    width: '100%',
  },
  [`& .${classes.dashboardDTUploadExportSectionMain}`]: {
    height: '90%',
    width: '100%',
    [up('xs')]: {
      paddingTop: '16px',
    },
    [up('md')]: {
      paddingTop: '20px',
    },
  },
  [`& .${classes.dashboardDocumentTypeMainGridEHContainer}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
    borderRadius: '10px',
    [up('xs')]: {
      height: '240px',
    },
    [up('md')]: {
      height: '280px',
    },
    [up('lg')]: {
      height: '300px',
    },
    [up('xl')]: {
      height: '340px',
    },
  },
  [`& .${classes.dashboardDTMainGridEHContainerSection}`]: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
  [`& .${classes.dashboardDocumentTypeMainGridFCContainer}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
    borderRadius: '10px',
    [up('xs')]: {
      height: '360px',
    },
    [up('md')]: {
      height: '400px',
    },
    [up('lg')]: {
      height: '440px',
    },
    [up('xl')]: {
      height: '480px',
    },
  },
  [`& .${classes.dashboardDTMainGridFCContainerSection}`]: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
  [`& .${classes.dashboardDTFlowSectionTitle}`]: {
    height: '10%',
    width: '100%',
  },
  [`& .${classes.dashboardDTFlowSectionMain}`]: {
    height: '90%',
    width: '100%',
  },
  [`& .${classes.ahNavigationButton}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '16px',
  },
  [`& .${classes.fcTableMainContainer}`]: {
    [up('xs')]: {
      height: '100%',
    },
    boxShadow: 'none',
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      width: '0px',
    },
  },
  [`& .${classes.fcTable}`]: {
    // border: `1px solid ${theme.palette.lunarBase.medium}`,
    // borderTop: 'none',
    // borderBottom: 'none',
  },
  [`& .${classes.fcTableRowClass}`]: {
    margin: '4px 0',
    border: `1px solid ${theme.palette.darkPurple.lighter}`,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
    },
  },
  [`& .${classes.fcNodeStepper}`]: {
    padding: 0,
    margin: 0,
    width: '100%',
    '& .MuiStep-root': { padding: 0, margin: 0 },
    '& .MuiStepLabel-root': { margin: 0, padding: 0 },
  },
  [`& .${classes.connectionLogoStyle}`]: {
    width: '20px',
    height: '20px',
  },
  [`& .${classes.connectionBoxStyle}`]: {
    background: theme.palette.primary.lighter,
    padding: '8px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.fcStatusChipPadding}`]: {
    padding: '0 4px',
    borderRadius: '5px',
  },
  [`& .${classes.fcStopChip}`]: {
    backgroundColor: theme.palette.colorRed.light,
    border: theme.palette.colorRed.dark,
  },
  [`& .${classes.fcRunningChip}`]: {
    backgroundColor: theme.palette.colorGreen.light,
    border: theme.palette.colorGreen.dark,
  },
  [`& .${classes.fcNameTypo}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [up('xs')]: {
      width: '40px',
    },
    [up('md')]: {
      width: '60px',
    },
    [up('lg')]: {
      width: '70px',
    },
    [up('xl')]: {
      width: '80px',
    },
  },
  [`& .${classes.fcTableRowCell}`]: {
    color: theme.palette.deepAmethyst.main,
    fontFamily: 'Heebo',
    fontWeight: 400,
    border: 'none',
  },
  [`& .${classes.dashboardDocumentTypeMainGridVDContainer}`]: {
    backgroundColor: theme.palette.secondaryWhite.main,
    borderRadius: '10px',
    [up('xs')]: {
      height: '360px',
    },
    [up('md')]: {
      height: '400px',
    },
    [up('lg')]: {
      height: '440px',
    },
    [up('xl')]: {
      height: '480px',
    },
  },
  [`& .${classes.dashboardDTMainGridVDContainerSection}`]: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
  [`& .${classes.dashboardDTValidateSectionTitle}`]: {
    height: '10%',
    width: '100%',
  },
  [`& .${classes.dashboardDTValidateSectionMain}`]: {
    height: '90%',
    width: '100%',
  },
  [`& .${classes.dashboardDocumentTypeMainGridTDContainer}`]: {
    // backgroundColor: theme.palette.secondaryWhite.main,
    borderRadius: '10px',
    [up('xs')]: {
      height: '360px',
    },
    [up('md')]: {
      height: '400px',
    },
    [up('lg')]: {
      height: '440px',
    },
    [up('xl')]: {
      height: '480px',
    },
  },
  [`& .${classes.dashboardDTMainGridTDContainerSection}`]: {
    height: '100%',
    alignContent: 'space-between',
  },
}));
